module.exports = __webpack_public_path__ + "a1fb663bab1f9279f0abd2ff5f58c137.woff2";